(function () {
  'use strict';

  /* @ngdoc object
   * @name closing
   * @description
   *
   */
  angular
    .module('finance.closing', [
      'ui.router',
      'ui.bootstrap'
    ]);
}());
